


































import { Vue, Component, PropSync, Watch } from "vue-property-decorator";

@Component({
  components: {},
})
export default class OtasIframe extends Vue {
  @PropSync("open", { default: false }) isOpen?: boolean;
  @PropSync("iframePropertyId", { default: null }) propertyId!: number | null;
  @PropSync("iframePropertyName", { default: null }) propertyName!: string | null;

  @Watch("open")
  async openWatch(fresh: boolean, old: boolean) {
    if (fresh && !old) {
      await this.loadIframe();
    }
  }

  iframeOpen = false;
  loading = false;
  iframeUrl = "";

  loadIframe() {
    this.loading = true;
    this.iframeUrl = "";
    Vue.axios
      .post("/channex/GetIframeUrl", { "propertyId": this.propertyId })
      .then((res) => {
        this.iframeOpen = true;
        this.iframeUrl = res.data.url;
      })
      .catch(() => {
        this.isOpen = false;
      })
      .finally(() => {
        this.loading = false;
      });
  }


  closeModal() {
    this.iframeOpen = false;
    this.isOpen = false;
  }
}
